{
  "title": "平台管理主控台總覽",
  "description": "了解平台管理主控台首頁（Dashboard）各區塊代表的意義，快速掌握需要處理的治理事項。",
  "headings": ["你會完成什麼", "適用角色", "操作前確認", "畫面說明", "完成後", "常見問題"],
  "summary": "看完後，您能判斷目前平台是否有待處理的治理事項，並知道如何前往對應的詳細清單頁。",
  "roleNote": "平台管理員（Super Admin）",
  "prerequisites": ["已具備 super_admin 角色", "已登入平台管理主控台（/platform）"],
  "pathLabel": "/platform（總覽）",
  "steps": [
    {
      "title": "1. 需要你處理",
      "description": "畫面最上方彙整目前偵測到的治理待辦事項：待審核的競賽申請件數、若目前僅剩 1 位啟用中超級管理員的風險提示、評審配對衝突提示。沒有待辦事項時會顯示明確的空狀態，不會留白。"
    },
    {
      "title": "2. 平台規模",
      "description": "顯示啟用中使用者數、競賽總數（含進行中／已結束或草稿的組成）、評審關係數；皆為平台整體的有界聚合值，非逐競賽細目。"
    },
    {
      "title": "3. 治理狀態",
      "description": "顯示已停權使用者數、平台管理員數；若您具有審核競賽申請的權限，會再加上待處理申請件數。"
    },
    {
      "title": "4. 營運健康度",
      "description": "顯示已註冊隊伍數、評分完成率；皆為平台整體的有界聚合值，非逐競賽細目。"
    },
    {
      "title": "5. 快速入口與近期活動",
      "description": "指標卡片下方提供使用者／競賽申請／評審／稽核四個快速入口；最下方是「近期重要治理活動」，預設隱藏表單欄位層級等雜訊性編輯紀錄，只顯示重要治理事件。"
    }
  ],
  "afterward": [
    "可依「需要你處理」卡片的提示，點擊直接前往對應的篩選／排序清單頁",
    "可透過左側導覽切換到「使用者」「評審治理」「管理員」「競賽」「稽核紀錄」等其他頁面"
  ],
  "nextSteps": "若「需要你處理」出現待審核的競賽申請，可直接點擊前往「競賽申請」頁面進行審核。",
  "faq": [
    {
      "q": "Dashboard 上的數字多久更新一次？",
      "a": "每項指標皆為每次載入時即時計算，沒有快取，也沒有獨立的資料表儲存這些聚合值；重新整理頁面即可看到最新結果。"
    },
    {
      "q": "為什麼我登入後看不到平台管理主控台？",
      "a": "這是預期行為：註冊與登入本身不會授予任何平台權限。/platform 僅 super_admin 可進入；若您是全新部署的第一位使用者，需先完成 Bootstrap 流程取得第一位 super_admin 身分。"
    }
  ]
}
